import React from "react"

ProductReviews.propTypes = {}

function ProductReviews(props) {
  return <div>Reviews</div>
}

export default ProductReviews
